import BigWinComponent from "ags/components/big-win-component";
import { BigWinThresholds } from "ags/utils/win-magnitude";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";
import soundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contracts/contract";
import DeviceInfo from "slotworks/utils/device-info";
import Timer from "slotworks/utils/timer";
import { BigWinFirework } from "../components/big-win-firework";

class BigWinCommand {

    private landscapeComponent: BigWinComponent;
    private portraitComponent: BigWinComponent;

    private bigWinLevel: BigWinThresholds;
    private timerId: number;
    private stopped: boolean = false;

    public start(bigWinLevel: BigWinThresholds) {

        this.bigWinLevel = bigWinLevel;
        this.stopped = false;

        Layers.CelebrationForeground.setScene("bigWin").execute();
        this.landscapeComponent = new BigWinComponent(bigWinLevel, Orientation.LANDSCAPE);

        if (!DeviceInfo.isDesktop) {
            this.portraitComponent = new BigWinComponent(bigWinLevel, Orientation.PORTRAIT);
            canvasManager.onOrientationChange.add((orientation: Orientation) => this.switchOrientation(orientation));
            this.switchOrientation(canvasManager.orientation);
        } else {
            this.landscapeComponent.setVisible(true);
        }

        if (bigWinLevel >= BigWinThresholds.BIG) {
            this.playCoinSounds();
        }

        if (bigWinLevel >= BigWinThresholds.HUGE) {
            this.timerId = this.launchFireworks();
        }
    }

    public stop(immediateStop = false) {
        return new Contract((resolve) => {

            this.stopped = true;

            if (this.bigWinLevel >= BigWinThresholds.BIG) {
                this.stopCoinSounds(immediateStop);
            }

            if (this.timerId) {
                Timer.clearInterval(this.timerId);
            }

            this.landscapeComponent.stop(immediateStop).then(() => resolve(null));
            if (this.portraitComponent) {
                this.portraitComponent.stop(immediateStop).execute();
            }
        });
    }

    protected launchFireworks() {
        return Timer.setInterval(() => new BigWinFirework(), 500);
    }

    protected stopCoinSounds(immediateStop = false) {
        soundManager.customEventContract("end_coins").then(() => {
            if (!immediateStop) {
                soundManager.customEvent("coins_end");
            }
        });
    }

    protected playCoinSounds() {
        soundManager.customEventContract("coins_start").then(() => {
            if (!this.stopped) {
                soundManager.customEvent("coins_loop");
            }
        });
    }

    protected switchOrientation(orientation: Orientation) {
        switch (orientation) {
            case Orientation.LANDSCAPE:
                this.landscapeComponent.setVisible(true);
                this.portraitComponent.setVisible(false);
                break;
            case Orientation.PORTRAIT:
                this.landscapeComponent.setVisible(false);
                this.portraitComponent.setVisible(true);
                break;
        }
    }
}

export default new BigWinCommand();
